import * as React from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

export interface IActionPaperProps {
    children: React.ReactNode,
    header?: {
        title?: string;
        caption?: string;
        flexEnd?: React.ReactNode,
    },
    divider?: boolean,
    content?: React.ReactNode,

}


export default function ActionPaper({ children, header, divider, content }: IActionPaperProps) {
    return (
        <Paper sx={{ height: '100%' }}>
            <Stack sx={{ height: '100%' }}>
                <Stack id="paper-action-head">
                    {!!(header && Object.keys(header)?.length > 1) && (
                        // header
                        <>
                            <Stack sx={{ p: '23px 17px' }} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                                <Stack spacing={2}>
                                    {header?.title && <Typography className="font-20">{header.title}</Typography>}
                                    {header?.caption && <Typography color="grey.100" className="font-14">{header.caption}</Typography>}
                                </Stack>
                                {header?.flexEnd && header?.flexEnd}
                            </Stack>
                            {divider && <Divider />}
                        </>
                    )}
                    {content && (
                        <Stack sx={{ p: '12px 17px' }}>
                            {content}
                        </Stack>
                    )}
                </Stack>
                {/* content */}
                <Stack sx={{ height: '100%' }} overflow={'auto'}>
                    {children}
                </Stack>
            </Stack>
        </Paper>
    );
}

